import * as React                           from 'react';

import { Button                           } from 'src/components/common/button';
import { Dialog                           } from 'src/components/common/dialog';

import { SAVE_NOW_FALSE                   } from 'src/components/features/inspection/edit/piece-edit-dialog';
import { Container, 
         Caption,
         Group,
         Message,
         Actions,
         CVCheckPieceFilesDialogVariants,
         cvcheckpiecefilesdialog_variants } from 'src/components/features/inspection/edit/cv-check-piece-files-dialog/ui';

import { useAppSelector, 
         storeApi,                  
         useAppDispatch                   } from 'src/store';



type Props = {
  variant: CVCheckPieceFilesDialogVariants;
}
export const CVCheckPieceFilesDialog: React.FC<Props> = ({
  variant,
}) => {
  const lookAndFeel = cvcheckpiecefilesdialog_variants.get(variant)!;
  const dispatch = useAppDispatch();
  const opened = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedCVCheckFilesResultOpened);
  const groups = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedCVCheckFilesResultGroup);
  const singles = useAppSelector(storeApi.inspection.edit.selectors.selectPieceEditedCVCheckFilesResultSingle);

  const cancelClickHandler = () => {
    dispatch(storeApi.inspection.edit.actions.pieceEditedCVCheckFilesResultClosed());
    dispatch(storeApi.inspection.edit.actions.pieceEditedSaveChanges());
    setTimeout(() => dispatch(storeApi.inspection.edit.async.saveImmediatelyAsync(SAVE_NOW_FALSE)), 200);
  }

  return (
    <Dialog variant = { lookAndFeel.dialogVariant } isOpened = { opened }>
      <Container lookAndFeel = { lookAndFeel }>
        <Caption lookAndFeel = { lookAndFeel }>
          Внимание
        </Caption>
        {Object.keys(groups).map((groupHeader) => (
          <Group lookAndFeel = { lookAndFeel }>
            <Message lookAndFeel = { lookAndFeel }>
              { groupHeader }
            </Message>
            {groups[groupHeader].map((groupMessage) => (
              <Message lookAndFeel = { lookAndFeel }>
                { groupMessage }
              </Message>
            ))}
          </Group>
        ))}
        {singles.map((singleMessage) => (
          <Message lookAndFeel = { lookAndFeel }>
            { singleMessage }
          </Message>
        ))}
        <Actions lookAndFeel = { lookAndFeel }>
          <Button
            variant = { lookAndFeel.buttonCancelVariant }
            label = 'Отмена'
            onTap = { cancelClickHandler }
          />
          <Button
            variant = { lookAndFeel.buttonOkVariant }
            label = 'Исправить'
            onTap = { () => dispatch(storeApi.inspection.edit.actions.pieceEditedCVCheckFilesResultClosed()) }
          />
        </Actions>
      </Container>
    </Dialog>
  );
};